module.exports = __webpack_public_path__ + "img/1.9271dd77.webp";